import * as React from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, CardHeader, CardBody, Table } from 'reactstrap';
import Breadcrumb from 'src/components/Common/Breadcrumb';
import { useGetNoticeTemplateDetailsListQuery } from 'src/rtk/features/setup/noticeTemplateDetails/setupNoticeTemplateDetailsApi';
import NoticeTemplateDetailsTableRow from './NoticeTemplateDetailsTableRow';

const NoticeTemplateDetails = () => {
  const { data, error, isLoading, isError } = useGetNoticeTemplateDetailsListQuery();

  const err: CustomError = error as CustomError;
  const noticeTemplateDetails = data?.data || [];   

  let content = null;

  if (isLoading) {
    content = <div className="mt-3">Loading...</div>;
  }
  if (!isLoading && isError && error) {
    content = <div className="mt-3">{err.message}</div>;
  }
  if (!isLoading && !isError && noticeTemplateDetails?.length > 0) {
    content = noticeTemplateDetails.map((noticeTemplateDetails: any, index: any) => (
      <NoticeTemplateDetailsTableRow
        noticeTemplateDetails={noticeTemplateDetails}
        index={index}
        key={noticeTemplateDetails.id}
      />
    ));
  } else {
    content = (
      <tr>
        <td colSpan={11}>
          <div className="text-center text-danger h6">No data available!</div>
        </td>
      </tr>
    );
  }
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="Notice Template Details List" breadcrumbItem="Notice Template Details List" />
        <Card>
          <CardHeader className="d-flex justify-content-end">
            <Link className="btn btn-sm btn-primary" to="/setup/notice-template-details/add">
              Add Notice Template Details
            </Link>
          </CardHeader>
          <CardBody>
            <div className="table-responsive">
              <Table className="table mb-0">
                <thead>
                  <tr>
                    <th>Sl. </th>
                    <th>Notice List</th>
                    <th>Details</th>                                     
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{content}</tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default NoticeTemplateDetails;
